module.exports = __webpack_public_path__ + "images/index/img01.ed7fe41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yuang/img01.jpg
// module id = 8w4P
// module chunks = 21